import { render, staticRenderFns } from "./lembur.vue?vue&type=template&id=19a60438"
import script from "./lembur.vue?vue&type=script&lang=js"
export * from "./lembur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports